module.exports = __webpack_public_path__ + "img/个性化欢迎语.37732c7b.svg";